import Vue from 'vue'

import 'normalize.css'
import SvgIcon from 'vue-svgicon'
import vueCompositionApi from '@vue/composition-api'

import '@/styles/index.less'

import App from '@/App.vue'
import store from '@/store'
import router from '@/router'
import '@/icons/components'
import '@/assets/element-theme/index.css'
import '@/assets/style/variable.less'
import '@/assets/style/reset.less'
import ElementUI from 'element-ui'
import VueClipboard from 'vue-clipboard2'
import resetElementConfig from './resetElementConfig'

// import '@/permission'
resetElementConfig()
Vue.use(ElementUI, { size: 'mini', closeOnClickModal: false })
Vue.use(VueClipboard)
Vue.use(vueCompositionApi)
Vue.config.productionTip = false
Vue.use(SvgIcon, {
  tagName: 'svg-icon',
  defaultWidth: '1em',
  defaultHeight: '1em'
})

new Vue({
  name: 'ZhikePC',
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
